import React from 'react';
import { Link } from 'react-router-dom';
import Marquee from 'react-fast-marquee';
import { thumbUrl } from '../utils/imageUrl';

const ProductMarquee = ({ products = [], speed = 40 }) => {
  if (!products?.length) return null;

  return (
    <div className="py-8 bg-gradient-to-r from-gray-50 via-white to-gray-50 border-y border-gray-200 overflow-hidden">
      <div className="container mx-auto px-4 mb-4 flex items-baseline justify-between">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          🔥 <span className="bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">Sélection Gaming</span>
        </h2>
        <Link
          to="/products"
          className="text-sm font-semibold text-cyan-600 hover:text-purple-600 transition"
        >
          Voir tout →
        </Link>
      </div>

      <Marquee gradient gradientColor="rgb(249, 250, 251)" gradientWidth={60} speed={speed} pauseOnHover>
        {products.map((p) => (
          <Link
            key={p.id}
            to={`/products/${p.id}`}
            className="mx-3 group block w-56 flex-shrink-0"
            data-testid={`marquee-product-${p.id}`}
          >
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden neon-hover hover:border-cyan-400 transition">
              <div className="relative aspect-square overflow-hidden bg-gray-100">
                <img
                  src={thumbUrl(p.image_url, 320) || 'https://via.placeholder.com/300'}
                  alt={p.name}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {p.stock === 0 && (
                  <div className="absolute top-2 right-2 bg-red-500 text-white text-[10px] font-bold px-2 py-1 rounded">
                    RUPTURE
                  </div>
                )}
              </div>
              <div className="p-3">
                <h3 className="text-gray-900 font-semibold text-sm line-clamp-1 group-hover:text-cyan-600 transition">
                  {p.name}
                </h3>
                <p className="text-cyan-600 font-bold mt-1">
                  {p.price.toLocaleString('fr-DZ')} DA
                </p>
              </div>
            </div>
          </Link>
        ))}
      </Marquee>
    </div>
  );
};

export default ProductMarquee;
